import {
  RegistrationStructuredTableMetadata,
  RegistrationStructuredTableRowMetadata,
} from 'notebook/integrations/registry/RegistrationTableConstants';
import {
  StructuredTable,
  StructuredTableKind,
  UnknownStructuredTable,
} from 'notebook/structured-tables/StructuredTableConstants';

export default function isRegistrationStructuredTable(
  table: unknown
): table is StructuredTable<RegistrationStructuredTableMetadata, RegistrationStructuredTableRowMetadata> {
  return (
    (table as UnknownStructuredTable).kind !== undefined &&
    StructuredTableKind[(table as UnknownStructuredTable).kind] === StructuredTableKind.REGISTRATION
  );
}
